// Протокол "Активный щит" (deus_schit, cost 6) — oneshot.
// +4 брони Герою до конца следующего хода + 4 урона случайному вражескому юниту.

import { applyDamage } from '../../combat.js';
import { dispatchUnitDied } from './hooks.js';
import { chargeInfluence } from './influence.js';

export const CARD_ID = 'deus_schit';
export const COST = 6;

export function canPlayShield(state, playerIdx) {
  const p = state.players[playerIdx];
  if (p.influence < COST) return { ok: false, reason: 'not_enough_influence' };
  return { ok: true };
}

export function playShield(state, playerIdx) {
  const can = canPlayShield(state, playerIdx);
  if (!can.ok) return can;
  const p = state.players[playerIdx];
  const enemy = state.players[1 - playerIdx];
  if (!chargeInfluence(state, playerIdx, COST)) return { ok: false, reason: 'not_enough_influence' };
  // +4 брони до конца следующего хода.
  const expireAfterTurn = state.currentTurn + 1;
  p.hero.tempArmorBands.push({ armor: 4, expireAfterTurn, source: 'aktivnyy_schit' });
  p.hero.current.armor += 4;
  state.log.add(`🛡 ${p.name}: Активный щит — Герой +4 брони до конца хода ${expireAfterTurn} (броня ${p.hero.armor})`);
  // 4 урона случайному вражескому юниту.
  const targets = enemy.unitsOnField();
  if (targets.length === 0) {
    state.log.add(`Активный щит: у противника нет юнитов — урон не нанесён`);
  } else {
    const target = targets[state.rng.int(targets.length)];
    const r = applyDamage(target, 4, { pierce: false });
    state.log.add(`⚡ Активный щит → ${target.name_ru} [${enemy.name}]: ${4} урона (HP ${target.hp + r.hpLost}→${target.hp}, броня ${target.armor + r.armorAbsorbed}→${target.armor})`);
    if (target.hp <= 0) {
      enemy.removeFromField(target);
      state.log.add(`✗ ${target.name_ru} [${enemy.name}] погибает`);
      dispatchUnitDied(state, { ownerIdx: enemy.id, card: target, killer: null, killerIdx: playerIdx, killerWasCounter: false });
    }
  }
  return { ok: true };
}
